// D:\DhammaKnowledgeBase\chat-ui\src\components\ChatWindow.js
import React, { useEffect, useRef } from 'react';
import ReactMarkdown from 'react-markdown'; // Import ReactMarkdown
import remarkGfm from 'remark-gfm';       // Import remarkGfm for GitHub Flavored Markdown
// import rehypeRaw from 'rehype-raw';     // Optional: Only if your Markdown responses include raw HTML

const ChatWindow = ({ messages }) => {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]); // Scroll to bottom whenever messages change

  return (
    <div className="chat-window">
      {messages.map((message, index) => (
        <div key={index} className={`chat-message ${message.sender}`}>
          <div className="message-content">
            {/* Conditional rendering for AI messages using ReactMarkdown */}
            {message.sender === 'ai' ? ( // Assuming 'ai' is the sender for the AI's responses
              <ReactMarkdown
                remarkPlugins={[remarkGfm]} // Apply GitHub Flavored Markdown plugins
                // rehypePlugins={[rehypeRaw]} // Uncomment if you need to support raw HTML in Markdown
              >
                {message.text}
              </ReactMarkdown>
            ) : (
              // For user messages, display as plain text
              <p>{message.text}</p>
            )}

            {message.timestamp && ( // Only display if timestamp exists
              <div className="message-timestamp">
                {/* Format the timestamp. It could be a Firestore Timestamp or a JS Date object */}
                {message.timestamp instanceof Date
                  ? message.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) // For JS Date
                  : message.timestamp?.toDate().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) // For Firestore Timestamp
                }
              </div>
            )}
          </div>
        </div>
      ))}
      <div ref={messagesEndRef} /> {/* Invisible element to scroll to */}
    </div>
  );
};

export default ChatWindow;